var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view_cont" }, [
    _c(
      "div",
      { staticClass: "view_desc" },
      [
        _c("div", { staticClass: "sub_tit" }, [_vm._v("Contents Link Detail")]),
        _vm._v(" "),
        _vm.gridData.length > 0
          ? _c(
              "div",
              [
                _c("toast-grid", {
                  key: _vm.gridKey,
                  attrs: {
                    gridId: "gridCmsDetail",
                    data: _vm.gridData,
                    columns: _vm.gridColumns,
                    options: _vm.gridOptions,
                    pageOptions: _vm.gridPageOptions,
                    theme: _vm.gridTheme,
                    isTotalCount: false
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit" }, [_vm._v("Contents Detail")]),
        _vm._v(" "),
        _vm.bizctt !== null
          ? _c("table", { staticClass: "data_table_ty2 mb-20" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [_vm._v("Title")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.CTTDESC) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Product Type")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.prodType) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Proudct Subtype")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.prodSubType) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v(".COM Product Type")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizcttlink[0].COMNMPRODTYPE) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v(".COM Product Subtype")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizcttlink[0].COMNMPRODSUBTYPE) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Write Lang")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.WRITELANG) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text_left" }, [_vm._v("GBM")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.NMGBM) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Create Date")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.DTCREATE) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Create User")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.SIDCREATENM) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Update Date")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.DTUPDATE) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text_left" }, [
                    _vm._v("Update User")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bizctt.SIDUPDATENM) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.ATTACHED.FILES")))
        ]),
        _vm._v(" "),
        _c("toast-grid", {
          key: _vm.gridKey,
          attrs: {
            gridId: "gridCmsDetailDownload",
            data: _vm.gridDataDownload,
            columns: _vm.gridColumnsDownload,
            options: _vm.gridOptions,
            pageOptions: _vm.gridPageOptions,
            theme: _vm.gridTheme,
            isTotalCount: false,
            click: _vm.onGridCellClick
          }
        }),
        _vm._v(" "),
        _vm.loadInnorix
          ? _c(
              "div",
              { staticStyle: { "margin-top": "60px" } },
              [
                _c("innorix-download", {
                  attrs: {
                    uploadId: "cmsDetail",
                    serviceType: "cms",
                    attachList: _vm.fileList,
                    encToken: _vm.encToken
                  }
                }),
                _vm._v(" "),
                _vm.fileList.length > 0
                  ? _c("dl", { staticClass: "attachment_link" }, [
                      _c("dt", [
                        _c(
                          "a",
                          {
                            staticClass: "txt_link",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.toggleLink($event)
                              }
                            }
                          },
                          [_vm._v("Having trouble downloading?")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c(
                          "ul",
                          _vm._l(_vm.fileList, function(file) {
                            return _c("li", { key: file.downloadUrl }, [
                              _c(
                                "a",
                                {
                                  staticClass: "txt_link",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getDownloadUrl(file)
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "ico_attach" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(file.filename) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap topLine" }, [
      _c(
        "a",
        {
          staticClass: "btn_white size_full",
          attrs: { href: "javascript:", title: "" },
          on: {
            click: function($event) {
              return _vm.$emit("back-to-list")
            }
          }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
              "\n        "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d0fcd8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d0fcd8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/cmsContents/CmsDetail.vue
// module id = XeoU
// module chunks = 0